import { HttpService } from '../services';
export class CyclingPotentialService {
  static async getCyclingPotential({
    point: {
      coordinates: [lng, lat]
    }
  }) {
    try {
      const {
        facility_distances: facilityDistances
      } = await HttpService.get('v1', `/bicycle_potential`, [{
        key: 'latitude',
        value: lat
      }, {
        key: 'longitude',
        value: lng
      }]);
      return {
        facilityDistances
      };
    } catch (err) {
      console.error('[CyclingPotentialService][getCyclingPotential]', err);
      throw err;
    }
  }
}